import moment from 'moment';


const DEFAULT_TIME_FORMAT = 'h:mm A';


function startsWith(str, chr) {
    return str.indexOf(chr) === 0;
}


class SimpleTime {
    constructor(hour, min) {
        this.hour = hour;
        this.min = min;
    }

    toMoment() {
        return moment().hour(this.hour).minutes(this.min);
    }

    toFormat() {
        return this.toMoment().format(DEFAULT_TIME_FORMAT);
    }

    toDisplay() {
        const format = this.toFormat();

        return {
            value: format,
            label: format
        };
    }
}

class QueryTime extends SimpleTime {
    constructor(hour, min) {
        super(hour, min);

        this.orgHour = hour;
        this.orgMin = min;
    }

    fromArr(arr) {
        if (arr) {
            this.hour = arr[0];
            this.min = arr[1];
            this.orgHour = arr[3];
            this.orgMin = arr[4];

            this.hour = isNaN(this.hour) ? null : this.hour;
            this.min = isNaN(this.min) ? null : this.min;
        }
    }
}


class ParseRules {
    /**
     * When no input, don't match anything
     *
     * @param {QueryTime} search
     * @return {*}
     */
    static noInput(search) {
        if (search.hour === null && search.min === null) {
            return false;
        }

        return null;
    }

    /**
     * Returns True when only hour is specified
     *
     * @param {QueryTime} search
     * @return {*}
     */
    static onlyHour(search) {
        if (search.hour !== null && search.min === null) {
            return true;
        }

        return null;
    }

    /**
     * Returns True only when hour and one minute is specified
     *
     * @param {QueryTime} search
     * @return {*}
     */
    static hourAndFirstMinute(search) {
        if (search.hour !== null && (search.min >= 0 && search.min < 6) && search.orgMin.length < 2) {
            return true;
        }

        return null;
    }
}


export default class TimeManager {
    constructor() {
        this.minutePossibilities = {
            "0":
                [0,1,2,3,4,5,6,7,8,9],
            "1":
                [1,10,11,12,13,14,15,16,17,18,19],
            "2":
                [2,20,21,22,23,24,25,26,27,28,29],
            "3":
                [3,30,31,32,33,34,35,36,37,38,39],
            "4":
                [4,40,41,42,43,44,45,46,47,48,49],
            "5":
                [5,50,51,52,53,54,55,56,57,58,59]
        };

        this.hourlyPairs = {
            "1":
                [
                    {"value":"01:00 AM","label":"01:00 AM"},
                    {"value":"01:30 AM","label":"01:30 AM"},
                    {"value":"10:00 AM","label":"10:00 AM"},
                    {"value":"10:30 AM","label":"10:30 AM"},
                    {"value":"11:00 AM","label":"11:00 AM"},
                    {"value":"11:30 AM","label":"11:30 AM"},
                    {"value":"12:00 AM","label":"12:00 AM"},
                    {"value":"12:30 AM","label":"12:30 AM"},
                    {"value":"01:00 PM","label":"01:00 PM"},
                    {"value":"01:30 PM","label":"01:30 PM"},
                    {"value":"10:00 PM","label":"10:00 PM"},
                    {"value":"10:30 PM","label":"10:30 PM"},
                    {"value":"11:00 PM","label":"11:00 PM"},
                    {"value":"11:30 PM","label":"11:30 PM"},
                    {"value":"12:00 PM","label":"12:00 PM"},
                    {"value":"12:30 PM","label":"12:30 PM"}
                ],
            "2":
                [
                    {"value":"02:00 AM","label":"02:00 AM"},
                    {"value":"02:30 AM","label":"02:30 AM"},
                    {"value":"02:00 PM","label":"02:00 PM"},
                    {"value":"02:30 PM","label":"02:30 PM"}
                ],
            "3":
                [
                    {"value":"03:00 AM","label":"03:00 AM"},
                    {"value":"03:30 AM","label":"03:30 AM"},
                    {"value":"03:00 PM","label":"03:00 PM"},
                    {"value":"03:30 PM","label":"03:30 PM"}
                ],
            "4":
                [
                    {"value":"04:00 AM","label":"04:00 AM"},
                    {"value":"04:30 AM","label":"04:30 AM"},
                    {"value":"04:00 PM","label":"04:00 PM"},
                    {"value":"04:30 PM","label":"04:30 PM"}
                ],
            "5":
                [
                    {"value":"05:00 AM","label":"05:00 AM"},
                    {"value":"05:30 AM","label":"05:30 AM"},
                    {"value":"05:00 PM","label":"05:00 PM"},
                    {"value":"05:30 PM","label":"05:30 PM"}
                ],
            "6":
                [
                    {"value":"06:00 AM","label":"06:00 AM"},
                    {"value":"06:30 AM","label":"06:30 AM"},
                    {"value":"06:00 PM","label":"06:00 PM"},
                    {"value":"06:30 PM","label":"06:30 PM"}
                ],
            "7":
                [
                    {"value":"07:00 AM","label":"07:00 AM"},
                    {"value":"07:30 AM","label":"07:30 AM"},
                    {"value":"07:00 PM","label":"07:00 PM"},
                    {"value":"07:30 PM","label":"07:30 PM"}
                ],
            "8":
                [
                    {"value":"08:00 AM","label":"08:00 AM"},
                    {"value":"08:30 AM","label":"08:30 AM"},
                    {"value":"08:00 PM","label":"08:00 PM"},
                    {"value":"08:30 PM","label":"08:30 PM"}
                ],
            "9":
                [
                    {"value":"09:00 AM","label":"09:00 AM"},
                    {"value":"09:30 AM","label":"09:30 AM"},
                    {"value":"09:00 PM","label":"09:00 PM"},
                    {"value":"09:30 PM","label":"09:30 PM"}
                ],
            "10":
                [
                    {"value":"10:00 AM","label":"10:00 AM"},
                    {"value":"10:30 AM","label":"10:30 AM"},
                    {"value":"10:00 PM","label":"10:00 PM"},
                    {"value":"10:30 PM","label":"10:30 PM"}
                ],
            "11":
                [
                    {"value":"11:00 AM","label":"11:00 AM"},
                    {"value":"11:30 AM","label":"11:30 AM"},
                    {"value":"11:00 PM","label":"11:00 PM"},
                    {"value":"11:30 PM","label":"11:30 PM"}
                ],
            "12":
                [
                    {"value":"12:00 AM","label":"12:00 AM"},
                    {"value":"12:30 AM","label":"12:30 AM"},
                    {"value":"12:00 PM","label":"12:00 PM"},
                    {"value":"12:30 PM","label":"12:30 PM"}
                ]
        };
    }

    combine(h, mList) {
        let res = mList.map(item => new SimpleTime(h, item).toDisplay());
        h += 12;
        res = res.concat(mList.map(item => new SimpleTime(h, item).toDisplay()));
        return res;
    }

    // This is called by the select widget
    search(input, callback) {
        const query = TimeManager.parseQuery(input);

        // Early exit for noInput
        if (ParseRules.noInput(query) === false) {
            callback(null, {
                options: []
            });
        } else if (ParseRules.onlyHour(query) === true) {
            callback(null, {
                options: this.hourlyPairs[query.hour]
            });
        } else if (ParseRules.hourAndFirstMinute(query) === true) {
            callback(null, {
                options: this.combine(query.hour, this.minutePossibilities[query.min])
            });
        } else {
            let res = [new SimpleTime(query.hour, query.min).toDisplay(), new SimpleTime(query.hour + 12, query.min).toDisplay()];
            callback(null, {
                options: res
            });
        }
    }

    static parseQuery(query) {
        const tObj = new QueryTime(null, null);

        if (query) {
            tObj.fromArr(TimeManager.prepareQuery(query));
        }

        return tObj;
    }

    static prepareQuery(query) {
        if (query) {
            // Clean the query
            query = query.trim().replace(/[A-Za-z\s]+/g, '');

            // Match for cleaned format
            const match = query.match(/^([\d]+):?([\d]+)?$/);

            if (match) {
                return [
                    parseInt(match[1], 10),
                    parseInt(match[2], 10),
                    false,
                    match[1],
                    match[2]
                ];
            }
        }

        return false;
    }

    static generateHourlyPairs() {
        // Used to generate Hourly Pairs above
        let values = {};
        for (let h = 0; h < 24; h += 1) {
            values[h] = [];
            for (let h2 = 0; h2 < 24; h2 += 1) {
                if (String(h2)[0] == String(h) || h === h2) {
                    values[h].push(new SimpleTime(h2, 0).toDisplay());
                    values[h].push(new SimpleTime(h2, 30).toDisplay());
                }
            }
        }

        return values
    }

    static generateMinutes() {
        // Used to generate minute possibilities above
        let values = {};
        for (let m = 0; m < 6; m += 1) {
            values[m] = [m];
            for (let m2 = m === 0 ? 1 : 0; m2 < 10; m2 += 1) {
                values[m].push(m2 + (m * 10));
            }
        }

        return values
    }
}

export default TimeManager;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/utils/TimeManager.js
 **/